import cardModuleState from "./cardModule/state";

export default {
  ...cardModuleState,
};
